import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { Box, TablePagination } from "@mui/material";
import { RowsTableMemberships } from "./RowsTableMemberships";
import FormMembershipModal from "../ModalMembership";
import ModalDetailsMembership from "../ModalDetailsMembership";
import ModalDeleteMembership from "../ModalDeleteMembership";
import ModalActivateMembership from "../ModalActivateMembership";

export default function TableMemberships({ rows = [], setLoading }) {
  const [page, setPage] = React.useState(0);
  const [showModalMembership, setShowModalMembership] = React.useState(false);
  const [selectedMembership, setSelectedMembership] = React.useState(null);
  const [showModalMembershipDetails, setShowModalMembershipDetails] =
    React.useState(false);
  const [shwoModalDeleteMembership, setShowModalDeleteMembership] =
    React.useState(false);
  const [showMosalActivateMembership, setShowModalActivateMembership] =
    React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = React.useMemo(() => {
    if (!rows || rows.length === 0) return [];

    return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, rows]);
  return (
    <>
      <FormMembershipModal
        membership={selectedMembership}
        open={showModalMembership}
        setOpen={setShowModalMembership}
        setLoading={setLoading}
      />
      <ModalDetailsMembership
        opne={showModalMembershipDetails}
        setOpen={setShowModalMembershipDetails}
        membershipData={selectedMembership}
      />
      <ModalDeleteMembership
        open={shwoModalDeleteMembership}
        membershipData={selectedMembership}
        setLoading={setLoading}
        setOpen={setShowModalDeleteMembership}
      />
      <ModalActivateMembership
        membershipData={selectedMembership}
        open={showMosalActivateMembership}
        setLoading={setLoading}
        setOpen={setShowModalActivateMembership}
      />
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>Nombre del Plan</TableCell>
                  <TableCell align="center">Precio</TableCell>
                  <TableCell align="center">Estatus</TableCell>
                  <TableCell align="center">Tipo de usuario</TableCell>
                  <TableCell align="center">Límite de rutas</TableCell>
                  <TableCell align="center">Plataforma</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((row) => {
                  return (
                    <RowsTableMemberships
                      key={row._id}
                      row={row}
                      showModalMembership={showModalMembership}
                      setShowModalMembership={setShowModalMembership}
                      setSelectedMembership={setSelectedMembership}
                      setShowModalMembershipDetails={
                        setShowModalMembershipDetails
                      }
                      setShowModalDeleteMembership={
                        setShowModalDeleteMembership
                      }
                      setShowModalActivateMembership={
                        setShowModalActivateMembership
                      }
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
}
